export default {
  title: 'Servicio de reservas de la empresa desactivado',
  description: 'El servicio de reservas está inactivo para esta empresa. Puedes activarlo en Servicios.',
  button: {
    settings: 'Ir a Configuración',
  },
};
